export type PasswordStrengthLevel = "Faible" | "Moyen" | "Fort";

export type PasswordStrengthResult = {
  score: number; // 0–4
  level: PasswordStrengthLevel;
  color: string; // Tailwind bg-* class
  widthPercent: number;
};

// Simple client-side heuristic — NOT a substitute for backend password
// policy enforcement (min length, common-password rejection, similarity to
// user info). This only gives the user quick visual feedback while typing.
export const getPasswordStrength = (
  password: string,
): PasswordStrengthResult => {
  if (!password) {
    return { score: 0, level: "Faible", color: "bg-gray-200", widthPercent: 0 };
  }

  let score = 0;

  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) {
    return {
      score,
      level: "Faible",
      color: "bg-red-500",
      widthPercent: 33,
    };
  }
  if (score <= 3) {
    return {
      score,
      level: "Moyen",
      color: "bg-yellow-500",
      widthPercent: 66,
    };
  }
  return {
    score,
    level: "Fort",
    color: "bg-green-500",
    widthPercent: 100,
  };
};
